export default "__VITE_ASSET__B65jPbnd__"